<template>
  <base-modal :modal-id="modalId">
    <template v-slot:header>
      <button
        type="button"
        class="d-sm-none btn btn-arrow"
        @click="$bvModal.hide(modalId)"
      >
        <img src="/images/svg/global/left_arrow.svg" />
      </button>

      <h4 class="modal-title mb-0 d-sm-none">{{ _T('Full Name') }}</h4>
      <h4 class="modal-title mb-0 d-none d-sm-block">
        {{ _T('Edit Profile') }}
      </h4>
    </template>
    <template v-slot:modal-body>
      <div class="change-profile">
        <ImageField
          @setImageData="setImageData"
          :avatar_url="web_user.avatar"
        ></ImageField>
      </div>
      <form class="default-form">
        <div class="form-group">
          <label class="d-none d-sm-block">{{ _T('Your Name') }}</label>
          <label class="d-sm-none">{{ _T('Full Name') }}</label>
          <input
            type="text"
            class="form-control"
            v-model="userName"
            :placeholder="web_user.name"
          />
        </div>
        <div class="btns">
          <button type="button" class="btn btn-outline" @click="closeModal()">
            {{ _T('Cancel') }}
          </button>
          <progress-bar v-if="processInProgress(process)">
            {{ _T('Saving') }}
          </progress-bar>
          <button
            v-else
            type="button"
            class="btn btn-danger"
            @click="changeNameAndImage()"
          >
            {{ _T('Save') }}
          </button>
        </div>
      </form>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import ImageField from '@/components/Elements/ImageField'
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/Elements/ProgressBar'
import { handleApiErrors } from '@/utils/main_utils.js'
export default {
  name: 'ChangeNameAndImage',
  components: {
    BaseModal,
    ImageField,
    ProgressBar,
  },
  data() {
    return {
      userAvatarImage: undefined,
      userName: undefined,
      process: 'change-name-avatar',
      modalId: 'change-profile',
    }
  },
  computed: {
    ...mapGetters(['_T', 'web_user', 'processInProgress']),
    getAvatarData() {
      if (this.userAvatarImage === undefined) {
        return this.web_user.avatar
      } else {
        return this.userAvatarImage
      }
    },
  },
  mounted() {
    this.userName = this.web_user.name
  },
  methods: {
    closeModal() {
      if (this.processInProgress(this.process))
        this.$store.dispatch('stopProcess', this.process)
      this.$bvModal.hide(this.modalId)
    },
    changeNameAndImage() {
      if (!this.userName) {
        this.$store.dispatch('showNotification', {
          text: this._T('Name is required'),
          status: 'error',
        })
      } else {
        if (!this.processInProgress(this.process)) {
          this.$store.dispatch('startProcess', {
            process: this.process,
            progress: true,
          })
          this.$store
            .dispatch('update_user_avatar_name', {
              avatar: this.getAvatarData,
              name: this.userName,
            })
            .then(resp => {
              let responseData = resp.data
              if (responseData.status === 'form_errors') {
                let errors = handleApiErrors(responseData.form_errors)
                this.$store.dispatch('showNotification', {
                  text: this._T(errors),
                  status: 'error',
                })
              } else {
                this.$store.dispatch('showNotification', {
                  text: this._T('Record updated succesfully'),
                  status: 'success',
                })
                this.$bvModal.hide(this.modalId)
              }
            })
            .catch(() => {
              this.$store.dispatch('showNotification', {
                text: this._T('Your request was not successfull'),
                status: 'error',
              })
            })
            .finally(() => {
              this.$store.dispatch('stopProcess', this.process)
            })
        }
      }
    },
    setImageData(data) {
      this.userAvatarImage = data
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
    .edit-profile {
      .modal-body {
        .btns {
          text-align: left;
          .btn {
            + .btn {
              margin-right: $px8;
              margin-left: unset;
            }
          }
        }

        label {
          text-align: right;
          float: right;
        }
      }
    }
  }
.change-profile {
  @include responsive(sm) {
    display: none;
  }
  text-align: center;
  margin: 0 auto
    calc(#{$px30} + (95 - 30) * ((100vw - #{$px320}) / (1920 - 320)));
  width: $px250;
  height: $px250;
  position: relative;

  &:hover {
    /deep/ .change-hover {
      opacity: 1;
      border-radius: 0%;
      transform: scale(1);
      transition: all 0.3s ease;

      .btn {
        background-color: #dddddd !important;
      }
    }
  }

  /deep/ img {
    width: $px250;
    height: $px250;
  }

  /deep/ .change-hover {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(var(--color-font-color-source), 0.8);
    opacity: 0;
    border-radius: 100%;
    transform: scale(0);
    transition: all 0.3s ease;

    /deep/ .updateimg {
      opacity: 0;
      position: absolute;
      left: $px44;
      width: $px162;
    }
  }
}
</style>
